import {h} from 'preact';
import Icon from '@components/common/Icon';
import {appendHashToUrl} from '@util/URLUtils';
import {dropMenuNav} from '../../styles';

const NavItem = ( {sysId, title, url = '/', urlHash, cssClass, children} ) =>
    <li data-menu-id={sysId} className={cssClass}>
        <a href={appendHashToUrl( url, urlHash )} data-prevent-touch-nav className={dropMenuNav.item}>
            {cssClass &&
            <Icon.embed name={cssClass} className="svgi-nav-prodfam text-lg mr-2"/>
            }
            <span className="nav-item--label">{title}</span>
        </a>

        {children}
    </li>;

export default NavItem;